var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManualSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0472 12.0005C23.0472 17.575 18.5559 22.1066 13.0001 22.1066C7.44421 22.1066 2.95288 17.575 2.95288 12.0005C2.95288 6.42611 7.44421 1.89453 13.0001 1.89453C18.5559 1.89453 23.0472 6.42611 23.0472 12.0005ZM13.0001 20.9846C17.9293 20.9846 21.9253 16.9623 21.9253 12.0005C21.9253 7.03878 17.9293 3.01648 13.0001 3.01648C8.07079 3.01648 4.07483 7.03878 4.07483 12.0005C4.07483 16.9623 8.07079 20.9846 13.0001 20.9846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 20.0449C17.4542 20.0449 21.0616 16.4412 21.0616 12.0002C21.0616 7.55915 17.4542 3.95545 12.9999 3.95545C8.54552 3.95545 4.93811 7.55915 4.93811 12.0002C4.93811 16.4412 8.54552 20.0449 12.9999 20.0449ZM12.9999 21.1668C18.0719 21.1668 22.1836 17.0628 22.1836 12.0002C22.1836 6.93755 18.0719 2.8335 12.9999 2.8335C7.92785 2.8335 3.81616 6.93755 3.81616 12.0002C3.81616 17.0628 7.92785 21.1668 12.9999 21.1668Z",
    fill: "#DCE0E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.708978,
    y: 0.77258,
    width: 24.5821,
    height: 24.6998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.12195
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.12195
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualSelected);
export default __webpack_public_path__ + "static/media/manual-selected.e23f985956d2b832585d258fc1f80ceb.svg";
export { ForwardRef as ReactComponent };